var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-gaps",style:({
  width: `${_vm.width}px`
})})
}
var staticRenderFns = []

export { render, staticRenderFns }